import React, { createContext, useState, useContext } from 'react';
import { en } from '../translations/en';
import { de } from '../translations/de';
import { it } from '../translations/it';

export const LanguageContext = createContext();

export const useLanguage = () => useContext(LanguageContext);

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('en');
  
  const translations = {
    en,
    de,
    it
  };

  const t = translations[language];

  const switchLanguage = (lang) => {
    setLanguage(lang);
  };

  return (
    <LanguageContext.Provider value={{ language, switchLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};
